import React, { Component } from "react";
import styled from "styled-components";

import { TextLink } from "../components";
import AuthTemplate from "./AuthTemplate";
import SignUpForm from "./SignUpForm";

import routes from "../routes";

class SignUp extends Component {
  render() {
    return (
      <AuthTemplate title="Rejestracja">
        <SignUpForm />
        <CreateAccount>
          <Info>Masz już konto?</Info>
          <TextLink to={routes.signIn}>Zaloguj się</TextLink>
        </CreateAccount>
      </AuthTemplate>
    );
  }
}

const CreateAccount = styled.div`
  display: flex;
  margin-top: 10px;
`;

const Info = styled.div.attrs({
  className: "text-light"
})`
  font-size: 12px;
  font-weight: 300;

  margin-right: 5px;
`;

export default SignUp;



// WEBPACK FOOTER //
// ./src/auth/SignUp.js